import { Actions, Effect, ofType } from '@ngrx/effects';
import { CORE_ACTIONS } from '../constants/core-actions.constant';
import { IgenomicsCastAction } from '../interfaces/genomics-cast-action.interface';
import { Injectable } from '@angular/core';
import { flatMap } from 'rxjs/operators';

@Injectable()
export class EntityEffect {
  constructor(private actions$: Actions) { }

  @Effect()
  cast$ = this.actions$
    .pipe(
      ofType(CORE_ACTIONS.CAST_ACTION),
      flatMap((action: IgenomicsCastAction) => {
        return action.payload
          .then(payload => {
            return { type: action.callbackType, payload: payload};
          });
      })
  );

}
